import React, { useRef, useState } from "react";
import { colors, glyphs, useMediaQuery } from "../../Styles";
import { TableButton } from "../BaseComponents";
import { useTranslation } from "react-i18next";
import { createPortal } from "react-dom";
import { TablePrefs } from "./subComponents/tablePrefsWidget";

interface AreaLayoutProps {
  zIndex?: number
  headerArea?: JSX.Element;
  buttonArea?: JSX.Element;
  topArea?: JSX.Element;
  contentArea?: JSX.Element;
  editableTable?: boolean;
  additionalArea?: JSX.Element;
  bluePrint?: {
    disabled: boolean;
    onClick: () => void;
    startEnhancer: string | JSX.Element;
  }
}

export default function AreaLayout({ headerArea, buttonArea, contentArea, additionalArea, topArea, editableTable = false, zIndex, bluePrint }: AreaLayoutProps) {
  const { t } = useTranslation();
  const [tablePrefsState, setTablePrefsState] = useState<boolean>(false); 
  const tablePrefsRef = useRef<HTMLDivElement | null>(null);
  const tableHeightRef = useRef<HTMLDivElement | null>(null);
  const popoutTablePrefs = useMediaQuery(`(max-width: 1000px)`);
  
  const isEditableTable: boolean = editableTable && editableTable === true
  const mobile = useMediaQuery(`(max-width: 1080px)`);

  const _gridTemplateRows = "50px 1fr"

  const tablePrefs = ( additionalArea && tableHeightRef.current && 
    <TablePrefs content={additionalArea} popout={popoutTablePrefs} tableHeight={mobile ? "100%" : `${tableHeightRef.current.offsetHeight}px`}/>  
  )
  
  return (
    <div style={{ height: "100%", width: "100%", display: "grid", gridTemplateRows: _gridTemplateRows, boxSizing: "border-box", position: "relative" }}>

      {/* Top Area */}
      <div style={{ gridArea: "1/1/2/2", boxSizing: "border-box", width: "100%", padding: "0px 20px", display: "grid", gridTemplateColumns: mobile ? "1fr" : isEditableTable ? "1fr" : "1fr fit-content(100%)", gridTemplateRows: "50px" }}>
        {!isEditableTable && headerArea && <div style={{ marginBottom: "5px", gridArea: "1/1/2/2", display: "flex", alignItems: "end" }}>
          {headerArea}
        </div>}

        {buttonArea && <div style={{ display: "flex", justifyContent: "end", gap: "5px", gridArea: "1/2/2/3", zIndex: zIndex ? zIndex : 0}}>
          {buttonArea}
        </div>}
      </div>

      {/* Table Area */}
      {contentArea && <div ref={tableHeightRef} style={{
        gridArea: "2/1/3/2",
        height: "100%",
        boxSizing: "border-box",
        backgroundColor: colors.greyLightTertiary, 
        border: "5px solid " + colors.greyPrimary,
        borderRadius: "10px",
        overflow: "hidden",
        zIndex: zIndex ? zIndex : 0,
        display: "grid",
        gridTemplateRows: topArea ? "fit-content(100%) 1fr" : "1fr",
      }}>
        {topArea && <div style={{gridArea: "1/1/2/2", backgroundColor: colors.greyPrimary, display: "flex", justifyContent: "space-between", minHeight: "30px", padding: "10px", gap: "10px"}}>{topArea}</div>}
        {contentArea && <div style={{gridArea: "2/1/3/2", padding: "20px", overflow: "auto", scrollbarColor: " #D9D9D9 #D9D9D950", scrollbarWidth: "thin", height: "100%", boxSizing: "border-box", width: "100%" }}>{contentArea}</div>}
      </div>}

      {/* Blue Print */}
      {popoutTablePrefs && additionalArea && editableTable && (
        <div ref={tablePrefsRef} style={{zIndex: zIndex ? zIndex : 1, position: "absolute", bottom: "10px", transition: "all ease-in-out 0.5s", left: tablePrefsState ? "10px" : "-310px"}}>
          <TableButton
            content={t("animalPages.animals.tablePreferences", { defaultValue: "Table preferences" })}
            disabled={false}
            onClick={() => {setTablePrefsState(!tablePrefsState)}}
            startEnhancer={tablePrefsState ? glyphs.Close({}) : glyphs.Arrow({})}
            bottomPosition={220}
            leftPosition={305}
          />
          {tablePrefs}
        </div>
      )}
  
      { /* Additional Area */}
      {!popoutTablePrefs && additionalArea && editableTable && createPortal(
          <div style={{ zIndex: zIndex ? zIndex : 1, position: "absolute", top: "210px", bottom: "125px", left: "20px" }}>{tablePrefs}</div>,
      document.body)}

      {/* Blue Print */}
      {!isEditableTable && bluePrint && 
        <TableButton
          content={t("systemControls.blueprint.blueprint", { defaultValue: "blueprint" })}
          disabled={bluePrint.disabled}
          onClick={bluePrint.onClick}
          startEnhancer={bluePrint.startEnhancer}
        />
      }
    </div>
  )
}